import { type ReactNode, createContext } from 'react'

import {
  type SelectionMessages,
  useSelectionMessages,
} from '../lib/selection-messages-hook'

interface FrameBuilderSelectionContextProps {
  committedStateSelectionMessages: SelectionMessages
  selectedStateSelectionMessages: SelectionMessages
}

interface SelectionProviderProps {
  children: ReactNode
}

export const FrameBuilderSelectionContext =
  createContext<FrameBuilderSelectionContextProps>({
    committedStateSelectionMessages: {},
    selectedStateSelectionMessages: {},
  })

export const FrameBuilderSelectionProvider = ({
  children,
}: SelectionProviderProps) => {
  const [committedStateSelectionMessages, selectedStateSelectionMessages] =
    useSelectionMessages()

  return (
    <FrameBuilderSelectionContext.Provider
      value={{
        committedStateSelectionMessages,
        selectedStateSelectionMessages,
      }}
    >
      {children}
    </FrameBuilderSelectionContext.Provider>
  )
}
